import { render } from "./ArticleDetailView.vue?vue&type=template&id=b379a47c&scoped=true"
import script from "./ArticleDetailView.vue?vue&type=script&lang=js"
export * from "./ArticleDetailView.vue?vue&type=script&lang=js"

import "./ArticleDetailView.vue?vue&type=style&index=0&id=b379a47c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b379a47c"]])

export default __exports__